
function asHtmlId(aString) {
    return aString.replace(/ /g, "-").toLowerCase()
}

export { asHtmlId }
